/**
 * Servizio Circolari - lato Rappresentante (area associativa)
 * Chiamate REST verso /api/representative/circolari/* con il representative_token
 * (lo stesso di `repAxios` in representativeService.ts). Serve il permesso per
 * carica `associativa.circolari.read`: senza, le route rispondono 403
 * (`isSenzaPermesso(error)`); con il modulo spento 503 (`isCircolariDisattivate`).
 */
import { creaCircolariApi } from './circolariService';

// REST: usare REACT_APP_API_BASE_URL (include già /api), NON REACT_APP_API_URL (GraphQL).
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

const headersRappresentante = (): Record<string, string> => {
  const token = localStorage.getItem('representative_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const circolariRappresentanteApi = creaCircolariApi({
  base: `${API_BASE_URL}/representative/circolari`,
  headers: headersRappresentante,
});

/** Vero se l'errore è il 403 «le tue cariche non hanno il permesso». */
export const isSenzaPermesso = (error: any): boolean => error?.response?.status === 403;
